import React from 'react';
import classNames from 'classnames';

interface IIconFontProps {
    type: string;
    className?: string;
    title?: string;
    style?: React.CSSProperties;
    spin?: boolean;
    onClick?: (e: React.MouseEvent) => void;
}

const IconFont: React.ForwardRefRenderFunction<HTMLElement, IIconFontProps> = (props, ref) => {
    const { type, spin = false, className, ...otherProps } = props;
    if (!type) {
        return null;
    }
    const cls = classNames('x-icon iconfont-fx-pc', className, {
        spin,
        [`icon-${type}`]: type
    });
    return <i ref={ref} className={cls} {...otherProps} />;
};

export default React.forwardRef(IconFont);
